import React from 'react';
import { Flex, useMediaQuery } from '@chakra-ui/react';
import { MyProjectFragment } from '@src/generated/graphql';
import SanityImage from '@components/Shared/SanityImage';
import SanityText from '@components/Shared/SanityText';

type MiddleRowProps = Pick<
  MyProjectFragment,
  | 'middleTopImage'
  | 'middleBottomImage'
  | 'middleBottomTextRaw'
  | 'middleTopTextRaw'
>;

const MiddleRow: React.FC<MiddleRowProps> = ({
  middleBottomImage,
  middleBottomTextRaw,
  middleTopImage,
  middleTopTextRaw,
}) => {
  const [isMobile] = useMediaQuery('(max-width: 767px)');
  const imageProps = isMobile
    ? { width: 768, height: 1121 }
    : { width: 328, height: 479 };
  return (
    <Flex
      justify="space-between"
      mb={['30px', null, '72px']}
      w="100%"
      direction={['column-reverse', null, 'row']}
    >
      <Flex
        direction="column"
        justify="space-between"
        flex={2}
        maxW={[null, null, 353]}
        mr={[null, null, '20px']}
      >
        <SanityText content={middleTopTextRaw} mb={[5, null, '65px']} />
        <SanityImage
          sanityImage={middleBottomImage}
          layout="responsive"
          {...imageProps}
        />
      </Flex>
      <Flex direction="column" justify="space-between" flex={3} maxW={709}>
        <SanityImage sanityImage={middleTopImage} layout="responsive" />
        <SanityText
          content={middleBottomTextRaw}
          mt={[5, null, 0]}
          withoutBottomMargin
        />
      </Flex>
    </Flex>
  );
};

export default MiddleRow;
